export const environment = {
  production: true,
  version: '5.16.1',
  logo: 'icetexLOGO.png',
  logoWidth: 250,
  clientType: 'invergran',
  isLocalhost: true, // Desactiva el captcha

    cryptKey: "1kzEp}:E:+V}Ld[=,FuXfe#Cpq<z!",

  apiBaseUrl: 'https://desarrolloaws.datascoring.co:9976/',
  apiNewBackBaseUrl: 'https://api-ictx.arx-t7.com/api/ahorro/',
  apiSSRSurl: 'https://desarrolloaws.datascoring.co:9970/',
  urlPopGrafico: 'https://desarrolloaws.datascoring.co:9922/#/',
};
